var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinStationDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_pin_disconnected)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 22C42 30 38 38 26 46C14.8 38 10 30 10 22C10 13.1634 17.1634 6 26 6C34.8366 6 42 13.1634 42 22Z",
    fill: "#BD3032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 22C41.5 29.7223 37.6908 37.5197 26.0098 45.3915C15.0761 37.5057 10.5 29.7046 10.5 22C10.5 13.4396 17.4396 6.5 26 6.5C34.5604 6.5 41.5 13.4396 41.5 22Z",
    stroke: "#9E2628"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.0455L27.2857 15V21.9545H32L24.7143 32V25.0455H20Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_pin_disconnected",
    x: 0,
    y: 0,
    width: 52,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_pin_disconnected"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_pin_disconnected"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_pin_disconnected",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinStationDisconnected);
export default __webpack_public_path__ + "static/media/pin_station_disconnected.88b0a0f0e5143976ba7da367fca37687.svg";
export { ForwardRef as ReactComponent };